import { createSellerInfo, updateUserInfo } from "@/graphql/mutations";
import { executeGraphQLMutation } from "@/utils/helper/graphql-helper";
import ls from "@/utils/SecureLS";
import { v4 as uuidv4 } from "uuid";
import React, { useCallback, useMemo, useState } from "react";


import { DistributorRegistrationForm } from "@/components";
import { BusinessFormValues } from "@/schemas/sellerRegistrationSchema";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
const SellerRegistration = () => {
  const userLS = ls.get("user");
  const user = useMemo(() => (userLS ? JSON.parse(userLS) : {}), [userLS]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();



  const handleSubmit = useCallback(
    async (data: BusinessFormValues) => {
      const seller = await executeGraphQLMutation({
        query: updateUserInfo,
        variables: {
          input: {
            id: user?.id,
            has_roles: [...(user?.has_roles || []), "seller"],
            updated_at: new Date().toISOString(),
          },
        },
      });
      if (seller) {
        const sellerBusinessInfo = await executeGraphQLMutation({
          query: createSellerInfo,
          variables: {
            input: {
              id: uuidv4(),
              user_id: user?.user_id,
              business_name: data?.businessName,
              description: data?.description,
              phone: data?.phone,
              street: data?.street,
              suite: data?.suite || "",
              city: data?.city,
              state: data?.state,
              country: data?.country,
              postal_code: data?.zipCode,
              is_verified:false,
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
            },
          },
          setLoading,
        });

        if (sellerBusinessInfo.id) {
         
          toast.success("Your request has been submitted!", {
            description: "Please Wait for Admin Approval!",
            duration: 5000,
          });

          const sellerUser = {
            ...seller,
            is_verified:false,
          };

          ls.set("user", JSON.stringify(sellerUser));

          navigate("/");



        }
      }
    },
    [user]
  );

  return (
    <>
      <DistributorRegistrationForm onSubmit={handleSubmit} loading={loading} />
    </>
  );
};

export default SellerRegistration;
